import { get } from 'lodash'

import { request } from '../../utils'

const URL_TRANSLATION = get(global, 'URL_TRANSLATION')

type TPayload = {
  [key: string]: any
}

export async function requestTranslations(
  payload: TPayload,
  etag: string,
): Promise<any> {
  const response = await request({
    method: 'post',
    url: URL_TRANSLATION,
    data: payload,
    headers: {
      'If-Match': etag,
    },
    validateStatus: (status) => status === 200 || status === 304,
  })
  return response
}
